import {ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import {InternationalRequest} from '@/helpers/InternationalRequest'
import {PanelUser} from '@/model/resource/PanelUser'

export class VisualizationMode extends Resource {
  idVisualizationModePk: ID = 0

  description: string | null = null

  @ResponseSerialize(PanelUser)
  responsaveis: PanelUser[] | null = null

  @ResponseSerialize(PanelUser)
  responsavelPermitido: PanelUser | null = null

  get $id() {
    return this.idVisualizationModePk
  }
  set $id(val) {
    this.idVisualizationModePk = val
  }

  get $tag() {
    return String(this.description)
  }

  async getVisualizationMode(id: number) {
    return await InternationalRequest.get(`/admin/visualization-mode/${id}`)
      .name('getVisualizationMode')
      .as(this)
      .getData()
  }

  static async removeResponsavelFromVisualizationMode(idPanelUser: number) {
    return await InternationalRequest.post(
      `/admin/visualization-mode/remove/${idPanelUser}`
    )
      .name('removeResponsavelVisualizationMode')
      .as(this)
      .getData()
  }

  async persistVisualizationMode() {
    return await InternationalRequest.post(`/admin/visualization-mode`, this)
      .name('persistVisualizationMode')
      .asNumber()
      .getData()
  }

  async persistResponsavelVisualizationMode() {
    return await InternationalRequest.post(
      `/admin/visualization-mode/persist-user-visualization-mode`,
      this
    )
      .name('persistResponsavelVisualizationMode')
      .as(this)
      .getData()
  }
}
